//
import Model from "@/models/Model"

/**
* @class
*/
export default class AccAccountingBankCard extends Model {
  
  /**
   * 
   */
  resource() {
    return "accounting_bank_card_chile"
  }
}